import * as React from "react";
import { inu } from "orbiter-core/src/basic";
import { connect } from "react-redux";
import { loadWallHandrails } from "../../loader";
import WallHandrailAPI from "../../apicontroller/staircasedata/WallHandrailAPI";
import { t } from 'ttag';
import MultiLanguageString from "orbiter-core/src/datastructures/languages/MultiLanguageString";
import { dt } from "webc-reactcore/src/js/stores/GlobalStore";
import WallHandrail from "../../../../../shared/datastructures/staircasedata/WallHandrail";
import SimpleSettingsTemplate from "./SimpleSettingsTemplate";
import { toSelectItems, createApiTitlePortalCollapsibleLanguageField, createApiDescriptionPortalCollapsibleLanguageField, createTitlePortalCollapsibleLanguageField, createDescriptionPortalCollapsibleLanguageField } from "./helper";
import ConfigBlock from "../../components/ConfigBlock";
import InfoScreen from "../../components/InfoScreen";
import MappedInput from "webc-reactcore/src/js/components/mainlayout/MappedInput";
import ImagePreviewUploadZone from "../../components/ImagePreviewUploadZone";

@(connect((store: any) => {
    return { settings: { ...store.settings }, globalInformation: { ...store.globalInformation } };
}) as any)
export default class WallHandrailSettings extends React.Component<any, any> {

    public wallHandrailsToSelectItems() {
        return toSelectItems<WallHandrailAPI>("wallhandrail", this.props.globalInformation.wallHandrails.sort((x, y) => dt(x.getTitle()) < dt(y.getTitle()) ? -1 : 1), (x) => WallHandrailAPI.clone(x), (x) => dt(x.getTitle()));
    }

    private async createEmpty(): Promise<WallHandrail> {
        return new WallHandrail(new MultiLanguageString(), new MultiLanguageString(), 0);
    }

    private async create(data: WallHandrail) {
        await WallHandrailAPI.create(data);
    }

    public render() {
        return <SimpleSettingsTemplate
            title="Muurleuning types"
            selectItems={this.wallHandrailsToSelectItems()}

            reload={loadWallHandrails.bind(this)}
            createEmpty={this.createEmpty.bind(this)}
            create={this.create.bind(this)}
            clone={(i: WallHandrailAPI) => WallHandrailAPI.clone(i)}

            renderEdit={this.renderEdit.bind(this)}
            renderCreate={this.renderCreate.bind(this)}

            infoScreen={<InfoScreen title={t`Selecteer een muurleuning.`} image={"/cdn/images/staircase.svg"} />}
        />;
    }

    private renderEdit(a: WallHandrailAPI, setSelected: (i: WallHandrailAPI) => void) {
        return this.doRender(
            createApiTitlePortalCollapsibleLanguageField(a, (x) => WallHandrailAPI.clone(x), setSelected.bind(this)),
            createApiDescriptionPortalCollapsibleLanguageField(a, (x) => WallHandrailAPI.clone(x), setSelected.bind(this)),
            <MappedInput placeholder={t`Prijs`}
                onBlur={(price) => {
                    const cl: WallHandrailAPI = WallHandrailAPI.clone(a);
                    try {
                        cl.getData().setPrice(price);
                    } catch (e) {
                        cl.getData().setPrice(0);
                    }
                    setSelected(cl);
                }}
                value={inu(a, (a) => a.getPrice(), () => "")} />,
            <ImagePreviewUploadZone
                imagePreviewIds={a.getImagePreviewIds()}
                onChange={(imagePreviewIds: string[]) => {
                    const cl: WallHandrailAPI = WallHandrailAPI.clone(a);
                    cl.getData().setImagePreviewIds(imagePreviewIds);
                    setSelected(cl);
                }}
            />,
        );
    }

    private renderCreate(a: WallHandrail, setSelected: (i: WallHandrail) => void) {
        return this.doRender(
            createTitlePortalCollapsibleLanguageField(a, setSelected.bind(this)),
            createDescriptionPortalCollapsibleLanguageField(a, setSelected.bind(this)),
            <MappedInput placeholder={t`Prijs`}
                onBlur={(price) => {
                    const cl: WallHandrail = a.clone();
                    try {
                        cl.setPrice(price);
                    } catch (e) {
                        cl.setPrice(0);
                    }
                    setSelected(cl);
                }}
                value={inu(a, (a) => a.getPrice(), () => "")} />,
            <ImagePreviewUploadZone
                imagePreviewIds={a.getImagePreviewIds()}
                onChange={(imagePreviewIds: string[]) => {
                    const cl: WallHandrail = a.clone();
                    cl.setImagePreviewIds(imagePreviewIds);
                    setSelected(cl);
                }}
            />,
        );
    }

    private doRender(
        titlePCLF: React.ReactNode,
        descriptionPCLF: React.ReactNode,
        priceMI: React.ReactNode,
        imagePreviewMI: React.ReactNode,
    ): React.ReactNode {
        return <div className={"container-fluid"}>
            <div className="row">
                <div className="col-md-6">
                    <ConfigBlock
                        title="Titel"
                        description="Geef een titel in voor deze muurleuning."
                        topMost={true}
                    >
                        {titlePCLF}
                    </ConfigBlock>

                    <ConfigBlock
                        title="Prijs"
                        description="Geef een prijs per lopende meter in voor deze muurleuning."
                        topMost={false}
                    >
                        {priceMI}
                    </ConfigBlock>
                </div>
                <div className="col-md-6">
                    <ConfigBlock
                        title="Omschrijving"
                        description="Geef een omschrijving in voor deze muurleuning."
                        topMost={true}
                    >
                        {descriptionPCLF}
                    </ConfigBlock>

                    <ConfigBlock
                        title="Afbeeldingen"
                        description="Upload afbeeldingen waarop dit muurleuning type te zien is."
                        topMost={false}
                    >
                        {imagePreviewMI}
                    </ConfigBlock>
                </div>
            </div>
        </div>;
    }
}
